import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeuserComponent } from '../homeuser/homeuser.component';
import { CaissierComponent } from '../caissier/caissier.component';
import { GestionnaireComponent } from '../admin/gestionnaire/gestionnaire.component';
import { EspaceClientComponent } from '../espace-client/espace-client.component';
import { BspaceComponent } from '../bspace/bspace.component';
import { BussnessTransactionComponent } from '../bussness-transaction/bussness-transaction.component';
import { ProfileComponent } from '../profile/profile.component';
import { TransfertComponent } from '../transfert/transfert.component';
import { StatisticComponent } from '../statistic/statistic.component';
import { MesAchatsComponent } from '../mes-achats/mes-achats.component';
import { MesDepotsComponent } from '../mes-depots/mes-depots.component';
import { MesRetraitsComponent } from '../mes-retraits/mes-retraits.component';
import { MesTransfertComponent } from '../mes-transfert/mes-transfert.component';
import { MesMensualiteComponent } from '../mes-mensualite/mes-mensualite.component';
import { AffairesAchatsComponent } from '../affaires-achats/affaires-achats.component';
import { AffairesDepotsComponent } from '../affaires-depots/affaires-depots.component';
import { AffairesMensualitesComponent } from '../affaires-mensualites/affaires-mensualites.component';
import { AffairesRetraitsComponent } from '../affaires-retraits/affaires-retraits.component';
import { AffairesFacturationsComponent } from '../affaires-facturations/affaires-facturations.component';
import { AffaireTransfertComponent } from '../affaire-transfert/affaire-transfert.component';
import { IdentificationComponent } from '../identification/identification.component';
import { RoleGuardService } from '../service/security/role-guard.service';

const routes: Routes = [
  {
    path: 'utilisateur/codes',
    component: HomeuserComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'ajouter/caisier/:name/:id',
    component: CaissierComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateur/gestionnaire/espace',
    component: GestionnaireComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['GESTIONNAIRE'] }
  },
  {
    path: 'utilisateur/espace-client',
    component: EspaceClientComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateur/bspace',
    component: BspaceComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER', 'CAISSIER'] }
  },
  {
    path: 'utilisateur/espace/busnes/activite/:name/:id',
    component: BussnessTransactionComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'informations/personel',
    component: ProfileComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateur/transaction',
    component: TransfertComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateur/statistiques',
    component: StatisticComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/affaire/achats/:id',
    component: AffairesAchatsComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/affaire/depots/:id',
    component: AffairesDepotsComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/affaire/mensualites/:id',
    component: AffairesMensualitesComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/affaire/retraits/:id',
    component: AffairesRetraitsComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/affaire/facturations/:id',
    component: AffairesFacturationsComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/affaire/transfert/:id',
    component: AffaireTransfertComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/achats',
    component: MesAchatsComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/identification',
    component: IdentificationComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/depots',
    component: MesDepotsComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/retraits',
    component: MesRetraitsComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/transferts',
    component: MesTransfertComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  },
  {
    path: 'utilisateurs/mensualites',
    component: MesMensualiteComponent,
    canActivate: [RoleGuardService],
    data: { expectedRole: ['USER'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
